import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import TopBar from '../TopBar';
import NavBar from './NavBar';

import { getRepositories } from '../../actions/repositoryActions';

import AdminContextProvider from '../../context/AdminContext';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    flexFlow: 'column',
    height: '100%',
    overflow: 'auto',
  },
  box: {
    height: '100%',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    height: '100%',
    width: '100%',
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    width: '100%'
  },
  content: {
    display: 'flex',
    flex: '1 1 auto',
    width: '100%',
    flexFlow: 'column',
    height: '100%',
  },
}));

function AdminLayout({ children }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);

  useEffect(() => {
    dispatch(getRepositories());
  }, [dispatch]);

  const getRole = () => {
    if (account.user.isAdmin) {
      return 'Admin';
    }
    if (account.user.isManager) {
      return 'Manager';
    }
    if (account.user.isManagerOfUsers) {
      return 'Manager Of Users';
    }
    return 'User';
  };

  return (
    <AdminContextProvider>
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content}>
              <Box>
                <TopBar role={getRole()} displayRepo={false} />
                <NavBar role={getRole()} />
              </Box>
              {children}
            </div>
          </div>
        </div>
      </div>
    </AdminContextProvider>
  );
}

AdminLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AdminLayout;
